<div class="box-wrap with-head p-nach">
    <div class="box-header">
      Physical NACH Form
      <div class="second-title">NACH Details</div>
    </div>
    <div class="box-content">
      <div class="pnach-inner">
        <div class="left">
          <div class="step-label">Step 1: Download Form</div>
          <div class="input-box" (click)="downloanForm()">
            <div class="box-text">Download NACH</div>
            <div class="ico-sec" *ngIf="!isEnableUpload && !isPnachformDownloaded">
              <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
                <path d="M9.99841 9.33008V11.1075C9.99841 11.5983 9.60052 11.9962 9.1097 11.9962H2.88871C2.39789 11.9962 2 11.5983 2 11.1075V9.33008" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.78125 7.10815L6.00303 9.32993L8.22481 7.10815" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.99952 9.33007V3.9978" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <img *ngIf="isEnableUpload || isPnachformDownloaded" src="assets/images/icons/tick_green_filled.svg" alt="icon"/>
          </div>
          <div class="step-label">Step 2: Print, sign & upload the copy</div>
          <div class="input-box error "(click)="nachUpload.click()" [ngClass]="{'disabled':!isEnableUpload && !isPnachformDownloaded}">
            <input #nachUpload type="file" accept="image/png,image/jpeg" [disabled]="!isEnableUpload && !isPnachformDownloaded"  (change)="uploadDoc($event)" class="upload-input"/>
            <div class="box-text">Upload NACH</div>
            <div class="ico-sec" *ngIf="fileIds.length ==0">
              <svg class="upload" width="12" height="13" viewBox="0 0 12 13" fill="none">
                <path d="M2.00159 3.66992V1.8925C2.00159 1.40168 2.39948 1.00379 2.8903 1.00379L9.11129 1.00379C9.60211 1.00379 10 1.40168 10 1.8925V3.66992" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.21875 5.8916L5.99697 3.66982L3.77519 5.8916" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.00048 3.66968L6.00048 9.00195" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <img *ngIf="fileIds.length >0" src="assets/images/icons/tick_green_filled.svg" alt="icon"/>
            <span class="err-text" *ngIf="isShowReuploadErrMsg">Please reupload NACH</span>
          </div>

        </div>
        <div class="right">
          <div class="pair-col">
            <div class="pair-label tag">Customer Name</div>
            <div class="pair-value">{{selectedBanks?.name | titlecase}}</div>
          </div>
          <div class="pair-col">
            <div class="pair-label">Account Number</div>
            <div class="pair-value">XXXX XXXX XX{{(selectedBanks?.accountNo + '').substr(-4)}}</div>
          </div>
          <div class="pair-col">
            <div class="pair-label">1st Installment</div>
            <div class="pair-value">{{nachData?.firstInstallmentDate | date :'dd/MM/yyyy'}}</div>
          </div>
          <div class="pair-col">
            <div class="pair-label">IFSC Code</div>
            <div class="pair-value">{{selectedBanks?.ifsc}}</div>
          </div>
          <div class="pair-col">
            <div class="pair-label">Debit Type</div>
            <div class="pair-value">{{nachData?.debitType}}</div>
          </div>
        </div>
      </div>
      <div class="page-action">
        <button class="btn-primary" (click)="pNachSubmit()" [disabled]="fileIds.length ==0">Continue</button>
      </div>
    </div>
  </div>
